import { SystemStyleObject } from '@chakra-ui/styled-system';

const rootSx: SystemStyleObject = {
  border: '1px solid',
  borderColor: 'borderBase',
  borderRadius: 4,
  bg: 'surface2',
  py: 3.5,
  px: 3,
  ':has(span:focus-visible)': {
    boxShadow: '0px 0px 8px 0px var(--chakra-colors-B-50)',
  },
};

const rootWrapperSx: SystemStyleObject = {
  position: 'relative',
  overflow: 'auto',
  flex: 1,
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1,
  minH: '25px',
  pr: 5,
};

const iconSx: SystemStyleObject = {
  color: 'M.50',
  width: '16px',
  height: '16px',
};

const inputSx: SystemStyleObject = {
  flex: 1,
  mr: 5,
  textOverflow: 'ellipsis',
  minW: 'auto',
  color: 'textBase',
  _before: {
    content: 'attr(placeholder)',
  },
  _empty: {
    color: 'M.50',
  },
};

const clearIconSx: SystemStyleObject = {
  ...iconSx,
  width: 'initial',
  height: 'initial',
  color: 'iconBase',
  _hover: {
    cursor: 'pointer',
    color: 'textBase',
  },
  ml: 1,
};

const clearAllIconSx: SystemStyleObject = {
  ...clearIconSx,
  color: 'iconBase',
  position: 'absolute',
  top: 1,
  right: 0,
  _hover: {
    cursor: 'pointer',
    color: 'textBase',
  },
};

const tagSx: SystemStyleObject = {
  rounded: 2,
  flex: '0 0 auto',
  bg: 'surface1',
  px: 1,
  py: 1,
  maxWidth: 280,
  minH: 'auto',
  whiteSpace: 'noWrap',
};

export const styles = {
  rootSx,
  rootWrapperSx,
  tagSx,
  iconSx,
  inputSx,
  clearIconSx,
  clearAllIconSx,
};
